import {reactive, ref} from "vue";
import {ObjectSchema, ValidationError} from "yup";

export interface TypedSchemaError {
    path?: string;
    errors: string[];
}

const errors = ref<any>([]);
async function handleSubmit(schema: ObjectSchema<any>, model: any) {
    try {
        errors.value = [];
        await schema.validate(model, {abortEarly: false});
        return true;
    } catch (err) {
        const error = err as ValidationError;
        if (error.name !== "ValidationError") {
            throw err;
        }
        error.inner.forEach((it: ValidationError) => {
            errors.value = {...errors.value, [it.path!]: it.message};
        });
        return false;
    }
}

export function resetValidation() {
    errors.value = [];
}

export function useFormValidation() {
    return {
        handleSubmit,
        errors,
        resetValidation,
    };
}
